module.exports = __webpack_public_path__ + "static/chat-screen-63e35e99a2eeb4d9ef045a7056b0e89e.png";